import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import PersonDetails from "@/shared/model/personDetails";
import PersonDetailsId from "@/shared/model/personDetailsId";

interface Props {
  details?: PersonDetails
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationOfficeComponent',
  props: {
    details: { default: undefined }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", null, [
      _createElementVNode("tr", null, [
        _cache[0] || (_cache[0] = _createElementVNode("td", null, "E-Mail-Adressen", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).RegistrationOfficeEmails)
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[1] || (_cache[1] = _createElementVNode("td", null, "Kennzeichen-Präfixe", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).RegistrationOfficePrefixes)
          }, null, 8, ["value"])
        ])
      ]),
      _createElementVNode("tr", null, [
        _cache[2] || (_cache[2] = _createElementVNode("td", null, "Kreisschlüssel", -1)),
        _createElementVNode("td", null, [
          _createVNode(SogDataLabel, {
            value: __props.details?.getValue(_unref(PersonDetailsId).RegistrationOfficeDistrictKeys)
          }, null, 8, ["value"])
        ])
      ])
    ])
  ]))
}
}

})